"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var styles = require('./HeaderContainer.scss');
var HeaderContainer = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderContainer, _super);
    function HeaderContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderContainer.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className },
            React.createElement("div", { className: styles.header }, this.props.header),
            this.props.children));
    };
    HeaderContainer = tslib_1.__decorate([
        mobx_react_1.observer
    ], HeaderContainer);
    return HeaderContainer;
}(React.Component));
exports.default = HeaderContainer;
//# sourceMappingURL=HeaderContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-storage-accounts-option/lib/components/HeaderContainer.js
// module id = 3732
// module chunks = 2